const { ActionTypes } = require("../constants/action_types");

const initialState = false;

export const dashboardViewReducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case ActionTypes.DASHBOARD_VIEW:
            return payload; //sidebarShow 
        default:
            return state;
    }
};